import { render } from "./Body.vue?vue&type=template&id=537b2be2&scoped=true"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"

import "./Body.vue?vue&type=style&index=0&id=537b2be2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537b2be2"]])

export default __exports__